import { useEffect, useRef } from 'react';
import { useModalManagerStore } from './modalManagerStore';

export function useModalManagerFocusManagement() {
  const currentFocusTargets = useModalManagerStore(state => state.currentFocusTargets);
  const clearCurrentFocusTargets = useModalManagerStore(state => state.clearCurrentFocusTargets);

  const attemptsRef = useRef(0);
  const timeoutRef = useRef<number>();

  useEffect(() => {
    attemptsRef.current = 0;

    function updateFocus() {
      if (currentFocusTargets.length > 0 && attemptsRef.current < 5) {
        let i = 0;
        while (i < currentFocusTargets.length) {
          const target = currentFocusTargets[i];
          const $target = target && 'current' in target ? target.current : target;

          $target?.focus();

          if ($target && document.activeElement === $target) {
            clearInterval(timeoutRef.current);
            clearCurrentFocusTargets();
            i = Infinity;
          }
          i += 1;
        }
        attemptsRef.current += 1;
      } else {
        clearInterval(timeoutRef.current);
      }
    }
    timeoutRef.current = window.setInterval(updateFocus, 100);
    updateFocus();

    return () => {
      clearInterval(timeoutRef.current);
    };
  }, [currentFocusTargets, clearCurrentFocusTargets]);
}
